<template>
  <div id="app">
    <router-view/>

    <!-- <van-dialog class="messageDialog" v-model="messageDialog2" :close-on-click-overlay="false" :show-confirm-button="false" style="z-index:3005">
      <div class="messageInfoBox">
        <div class="messageInfoBoxTitle">
          <div class="messageInfoBoxTitleText">
            公告
          </div>
        </div>
        <div class="messageInfo_content">
          <p style="text-indent:0em">
            各位家长：
          </p>
          <p>
            即日起，“红领巾劳动吧”平台迎来新一轮迭代升级，系统将优化证书领取功能，具体如下：
          </p>
          <p>
            本学年，将继续延续8月份申领证书的时间节点，即8月31日24时前，用户满100分且通过审核后，收到“证书领取方式”提示，用户可根据系统提示领取纸质证书。用户无需提交任何申请，只需根据系统提示操作即可。
          </p>
          <p>
            9月1日零点，所有用户积分将清零，下学年证书领取方式将在9月发布公告。
          </p>
        </div>
        <img @click="closeFn2" class="closefff" src="@/assets/images/closefff.png" alt="">
      </div>
    </van-dialog> -->
    <!-- <van-dialog class="messageDialog" v-model="messageDialog" :close-on-click-overlay="false" :show-confirm-button="false" style="z-index:3005">
      <div class="messageInfoBox">
        <div class="messageInfoBoxTitle">
          <div class="messageInfoBoxTitleText">
            公告
          </div>
        </div>
        <div class="messageInfo_content">
          <p>
            亲爱的同学们，感谢大家近一年来的积极参与！
          </p>
          <p>
            新的一年，获取“红领巾爱劳动”江苏少先队“特色章”的规则有所调整：此后不再发放电子版证书，而改为更有纪念意义的纸质版证书。
          </p>
          <p>
            持续参与互动和活动，且表现优异的少先队员，通过人工审核后，系统会自动发放相关凭证，凭证可在“我的积分”页面下浏览保存。凭保存的凭证图片，可去指定地点领取纸质版证书。
          </p>
          <p>
            请获得凭证者保持电话畅通，留意手机短信。工作人员会将领取纸质版证书的方式通过短信发送到手机上。
          </p>
        </div>
        <img @click="closeFn" class="closefff" src="@/assets/images/closefff.png" alt="">
      </div>
    </van-dialog> -->
    <!-- <van-dialog class="messageDialog" v-model="messageDialog3" :close-on-click-overlay="false" :show-confirm-button="false" style="z-index:3005">
      <div class="messageInfoBox" style="height: 46rem;">
        <div class="messageInfoBoxTitle">
          <div class="messageInfoBoxTitleText">
            公告
          </div>
        </div>
        <div class="messageInfo_content" style="height: 38rem;">
          <p style="text-indent:0em">
            各位同学、家长：
          </p>
          <p>
            “红领巾劳动吧”新一轮证书发放即将启动。平台工作人员将对4月30日24时前积分达到100分的账号进行人工审核，请耐心等待。
          </p>
          <p>
            <span style="color:#098877">5月6日至15日期间，</span>审核通过的账号将在平台“我的积分”页面收到申领通知，出现“申领按钮”。届时，请用户及时填写正确的收件地址等信息。
          </p>
          <p>
            <span style="color:#098877">请注意，申领通道将于5月15日24时关闭，逾期无法申领。</span>我们将按申领顺序，以快递（到付）形式寄送证书。
          </p>
          <p style="color:#098877;word-break:break-all;">如有疑问，请实名加入QQ群927543496咨询，或在工作日向15195913589或15950468668发送短信咨询（只需发送至其中一个号码）。</p>
          <p>请大家耐心等待审核结果，并关注“红领巾劳动吧”官方信息更新。感谢大家的支持与配合！</p>
        </div>
        <img @click="closeFn3" class="closefff" src="@/assets/images/closefff.png" alt="">
      </div>
    </van-dialog> -->

    <van-dialog class="messageDialog" v-model="messageDialog4" :close-on-click-overlay="false" :show-confirm-button="false" style="z-index:3005">
      <div class="messageInfoBox" style="height: 46rem;">
        <div class="messageInfoBoxTitle">
          <div class="messageInfoBoxTitleText">
            公告
          </div>
        </div>
        <div class="messageInfo_content" style="height: 38rem;">
          <p style="text-indent:0em">
            各位同学、家长：
          </p>
          <p>
            “红领巾劳动吧”新一轮证书发放即将启动。平台工作人员将对
            <span style="color:#098877">11月14日24时前积分达到100分</span>
            的账号进行人工审核，
            <span style="color:#098877">审核于11月28日24时截止，</span>
            请耐心等待。（15日—28日审核期间，暂停获得积分）
          </p>
          <p>
            审核期间，通过的账号将在平台“我的积分”页面收到申领通知，出现
            <span style="color:#098877">“申领按钮”</span>
            即可申请领取。届时，请用户及时填写正确的收件地址等信息。申领成功后，我们将按申领顺序，以快递（到付）形式陆续寄送证书。
          </p>
          <p>
            <span style="color:#098877">请注意，申领通道将于12月1日24时关闭，逾期无法申领。</span>本轮领取过证书的用户，积分清零。
          </p>
          <p>
            <span style="color:#098877;word-break: break-all;">如有疑问，请实名加入QQ群751559080（红领巾劳动吧官方发布交流4群）咨询，</span>
            已加过1-3群的请不要重复添加。
          </p>
          <p>
            请大家耐心等待审核结果，并关注“红领巾劳动吧”官方信息更新。感谢大家的支持与配合！ 
          </p>
          <p style="text-align: right;">
            2025年11月10日
          </p>
        </div>
        <img @click="closeFn4" class="closefff" src="@/assets/images/closefff.png" alt="">
      </div>
    </van-dialog>
    <van-dialog class="certificateCollectionDialog" v-model="certificateCollectionShow" :close-on-click-overlay="false" :show-confirm-button="false" style="z-index:3000">
      <div class="certificateCollectionBox" v-if="certificateCollectionBoxShow">
        <div class="certificateCollection_title">
          <span>{{ loginInfo.luserName }}</span>
          <span>同学:</span>
        </div>
        <div class="certificateCollection_content" :style="{'margin-bottom': certificateCollectionBoxShow? '2.4rem':'1.8rem'}">
          <p style="text-indent: 2em;">你热爱劳动学习，积极参加实践坚持不懈在“红领巾劳动吧”平台分享自己的劳动成果，可获得纸质版证书。</p>
          <p>请选择证书领取方式：</p>
        </div>
        <div class="certificateCollection_buttonBox" :style="{'padding-bottom': certificateCollectionBoxShow? '5.5rem':''}">
          <div @click="certificateCollectionBoxShow = false;submitData.pickupMethod = 2">请留下快递收件信息</div>
        </div>
      </div>
      <div class="expressBox" v-if="!certificateCollectionBoxShow">
        <div class="express_title">请填写快递（到付）收件信息：</div>
        <div class="express_options">
          <div class="express_label">*收件人姓名</div>
          <input type="text" placeholder="请输入姓名" v-model="submitData.recipientsName">
        </div>
        <div class="express_options">
          <div class="express_label">*收件人电话</div>
          <input type="text" placeholder="请输入手机号" v-model="submitData.recipientsPhone">
        </div>
        <div class="express_options">
          <div class="express_label">*收件地址</div>
          <input type="text" placeholder="请输入详细收件地址（包含市区县）" v-model="submitData.recipientsAddress">
        </div>
        <div class="express_submit" @click="submitFn">提&nbsp;交</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import axios from 'axios'
import { signature } from "@/api/common";
import { info,hljPmethod,hljPmethodInfo } from '@/api/common.js'


export default {
  name: 'App',
  mounted() {
    this.init()
  },
  created(){
    
  },
  data(){
    return{
      shareTitle:'红领巾 劳动吧',
      shareDesc:'全国首个少先队员劳动教育实践网上平台',
      shareImg:'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg',
      messageDialog:false,
      messageDialog2:false,
      messageDialog3:false,
      messageDialog4:false,
      certificateCollectionShow:false,
      certificateCollectionBoxShow:true,
      loginInfo:{},
      informFlag:0,
      pickupFlag:0,
      submitData:{
        // 用户ID
        luserId:'',
        // 领取通知ID（当前传1）
        pickupInformId:1,
        // 线下证书领取方式：1-自取；2-快递
        pickupMethod:1,
        // 收件人姓名
        recipientsName:'',
        // 收件人联系电话
        recipientsPhone:'',
        // 收件人地址
        recipientsAddress:'',
        // 领取方式截图地址
        pickupMethodImg:'',
      }
    }
  },  
  methods:{
    init(){
      // alert(1)
      let _cookie = localStorage.getItem('cookie')
      if(!_cookie||_cookie=='undefined'){
        _cookie = ''
      }
      if(!_cookie){
        localStorage.clear()
      }
      // alert(3)
      // 分享勿动 zha
      let userAgent = navigator.userAgent;
      if (userAgent.indexOf("JHDNews") > -1) {
        this.$postMessageToApp({ type: "getUserInfoNoLogin" })
      }
      this.remInit()
      // 第一次公告
      let _messageDialogStatus = localStorage.getItem('messageDialog')
      if(!_messageDialogStatus){
        this.messageDialog = true
        localStorage.setItem('messageDialog',1)
      }
      // 第二次公告
      let _messageDialogStatus2 = localStorage.getItem('messageDialog2')
      if(!_messageDialogStatus2){
        this.messageDialog2 = true
        localStorage.setItem('messageDialog2',1)
      }
      // 第三次公告
      let _messageDialogStatus3 = localStorage.getItem('messageDialog3')
      if(!_messageDialogStatus3){
        this.messageDialog3 = true
        localStorage.setItem('messageDialog3',1)
      }

      let _messageDialogStatus4 = localStorage.getItem('messageDialog4')
      if(!_messageDialogStatus4){
        this.messageDialog4 = true
        localStorage.setItem('messageDialog4',1)
      }
      let _data = localStorage.getItem('loginInfo')

      if(_data&&_data!='undefined'){
        let _loginInfo = JSON.parse(_data)
        if(_loginInfo.luserId){
          info(_loginInfo.luserId).then(_res=>{
            if(_res.status == 200){
              localStorage.setItem('loginInfo',JSON.stringify(_res.data))
              // let _loginInfo = _res.data
              // if(_loginInfo){
              this.loginInfo = _res.data
              // console.log(this.loginInfo)
              this.submitData.luserId = this.loginInfo.luserId
              if(this.loginInfo.hasOwnProperty('informFlag')){
                this.informFlag = this.loginInfo.informFlag
              }
              if(this.loginInfo.hasOwnProperty('pickupFlag')){
                this.pickupFlag = this.loginInfo.pickupFlag
              }
              if(this.informFlag == 1 && !this.pickupFlag){
                this.certificateCollectionShow = true
              }
              
              if(this.pickupFlag == 1){
                
                hljPmethodInfo(this.submitData.luserId).then(res=>{
                  // console.log(res)
                  if(res.status == 200){
                    localStorage.setItem('hljPmethod',JSON.stringify(res.data))
                  }
                })
              }
              // console.log(this.loginInfo)
              // }
            }
          })
        }
      }
      // this.registerWX()
      
    },
    closeFn(){
      localStorage.setItem('messageDialog',1)
      this.messageDialog = false
    },
    closeFn2(){
      localStorage.setItem('messageDialog2',1)
      this.messageDialog2 = false
    },
    closeFn3(){
      localStorage.setItem('messageDialog3',1)
      this.messageDialog3 = false
    },
    closeFn4(){
      localStorage.setItem('messageDialog4',1)
      this.messageDialog4 = false
    },
    remInit(){
      let size = (document.body.getBoundingClientRect().width*2)/750/2*20;
      document.querySelector("html").style.fontSize = size+ "px";
    },
    registerWX() {
      let _url = location.href.split("#")[0];
      if(location.href.split("#")[1].indexOf('videoDetails')!=-1){
        return
      }
      let _this = this
      signature({ url: _url }).then(res => {
        const wxData = res.data;
        wx.config({
          debug: false,
          appId: wxData.appid,
          timestamp: wxData.timestamp,
          nonceStr: wxData.nonceStr,
          signature: wxData.signature,
          jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
        });
        wx.ready(() => {
          let wxData = {
            title: _this.shareTitle,
            desc: _this.shareDesc,
            link: _url,
            imgUrl: _this.shareImg
          };
          let pengyouquanData = {
            title: _this.shareTitle,
            desc: _this.shareDesc,
            link: _url,
            imgUrl: _this.shareImg
          };
          wx.updateAppMessageShareData(wxData);
          wx.updateTimelineShareData(pengyouquanData);
        });
      });
    },
    selfPickupSubmitFn(){
      hljPmethod(this.submitData).then(res=>{
        if(res.status == 200){
          this.certificateCollectionShow = false
          this.certificateCollectionBoxShow = true
          localStorage.setItem('hljPmethod',JSON.stringify(this.submitData))
          this.loginInfo.pickupFlag = 1
          localStorage.setItem('loginInfo',JSON.stringify(this.loginInfo))
          this.submitData = {
            // 用户ID
            luserId: this.submitData.luserId,
            // 领取通知ID（当前传1）
            pickupInformId:1,
            // 线下证书领取方式：1-自取；2-快递
            pickupMethod:1,
            // 收件人姓名
            recipientsName:'',
            // 收件人联系电话
            recipientsPhone:'',
            // 收件人地址
            recipientsAddress:'',
            // 领取方式截图地址
            pickupMethodImg:'',
          }
          this.$toast('操作成功')
        }
      })
    },
    submitFn(){
      // this.submitData
      console.log(this.submitData)
      if(!this.submitData.recipientsName){
        this.$toast('请输入姓名')
        return
      }
      if(!this.submitData.recipientsPhone){
        this.$toast('请输入手机号')
        return
      }
      if(!this.submitData.recipientsAddress){
        this.$toast('请输入详细收件地址（包含市区县）')
        return
      }
      hljPmethod(this.submitData).then(res=>{
        console.log(res)
        if(res.status == 200){
          this.certificateCollectionShow = false
          this.certificateCollectionBoxShow = true
          this.loginInfo.pickupFlag = 1
          localStorage.setItem('loginInfo',JSON.stringify(this.loginInfo))
          this.submitData = {
            // 用户ID
            luserId: this.submitData.luserId,
            // 领取通知ID（当前传1）
            pickupInformId:1,
            // 线下证书领取方式：1-自取；2-快递
            pickupMethod:1,
            // 收件人姓名
            recipientsName:'',
            // 收件人联系电话
            recipientsPhone:'',
            // 收件人地址
            recipientsAddress:'',
            // 领取方式截图地址
            pickupMethodImg:'',
          }
          this.$toast('操作成功')
        }
      })
    }
  }
}
</script>

<style>
body{
  margin: 0px;
}
#app {
  width: 100vw;
  height: 100vh;
}

.flex {
  display: flex;
}

/*垂直居中*/

.flex-box {
  -webkit-box-align: center;
  align-items: center;
  -webkit-align-items: center;
}

/*均匀分列每个子集元素间距*/

.flex-justify {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

/*水平居中*/

.flex-center {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}

/*弹性盒子剩余的宽度*/

.flex-one {
  flex: 1;
  /* -webkit-flex: 1;
  -webkit-box-flex: 1; */
}

/*设置子集元素垂直排列兼容*/

.flex-direction {
  flex-direction: column;
  -webkit-flex-direction: column;
  -webkit-box-orient: vertical;
}

/*定位居中*/

.position-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}
/* 清除浮动 */
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
img{
  user-select: none;
}


.line1 {
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  display: -webkit-box!important;
  -webkit-line-clamp: 1!important;
  line-clamp: 1!important;
  -webkit-box-orient: vertical!important;
}
.line2 {
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  display: -webkit-box!important;
  -webkit-line-clamp: 2!important;
  line-clamp: 2!important;
  -webkit-box-orient: vertical!important;
}
.line3 {
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  display: -webkit-box!important;
  -webkit-line-clamp: 3!important;
  line-clamp: 3!important;
  -webkit-box-orient: vertical!important;
}
@media screen and (min-width:900px) {
  html{
    font-size: 10px!important;
  }
  #app{
    width: 375px;height: 100vh;
    margin: 0px auto;position: relative;
    box-shadow: 0 0px 5px #a59a9a;
  }
  .scroll{
    overflow-y: auto;
    border-radius: 4px;
  }
  .scroll::-webkit-scrollbar{
    /*滚动条整体样式*/
    width : 7px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 7px;
    border-radius: 5px;
    color: transparent;
  }
  .scroll::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 7px;
    background: #dadada;
    border-radius: 9px;
  }
  .scroll::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
  }
  .pageContainer,.videoContentBox{
    width: 375px!important;
  }
  .videoContentBox{
    left: 50%!important;
    transform: translateX(-50%)!important;
  }
  .pageContainer .returnBox{
    left: calc(50% - 165.5px)!important;
  }
  .home_index .van-dropdown-item{
    width: 375px!important;
    left: 50%;
    transform: translateX(-50%);
  }
  .bottom_tab{
    width: 375px!important;
  }
  .schoolInputSelectBox{
    width: 300px!important;
  }
  .van-tabbar{
    position: relative;
  }
  .van-sticky--fixed,.van-overlay,.van-popup,.van-image-preview{
    width: 375px!important;
    position: fixed;
    left: 50%!important;
    transform: translateX(-50%)!important;
  }
  .loadingOverlay{
    width: 375px;height: auto;
    /* display: flex;align-items: center;justify-content: center; */
  }
  .bottom_tab .van-sticky--fixed,.bottom_tab .van-overlay,.bottom_tab .van-popup,.van-image-preview{
    width: 375px;
    position: fixed;
    left: 50%!important;transform: translateX(-50%);
  }
  .van-image-preview img,.van-swipe__track,.van-swipe-item,.van-image{
    max-width: 375px;
  }
  .van-cascader__options,.schoolInputSelect{
    overflow-y: auto;
    border-radius: 4px;
  }
  .van-cascader__options::-webkit-scrollbar,.schoolInputSelect::-webkit-scrollbar{
    /*滚动条整体样式*/
    width : 7px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 7px;
    border-radius: 5px;
    color: transparent;
  }
  .van-cascader__options::-webkit-scrollbar-thumb,.schoolInputSelect::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 7px;
    background: #dadada;
    border-radius: 9px;
  }
  .van-cascader__options::-webkit-scrollbar-track,.schoolInputSelect::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
  }
  .bottom_tab{
    position: absolute!important;
  }
  .bottom_tab .van-tabbar--fixed{
    position: absolute;
  }
  .van-sticky--fixed{
    width: 375px;
    left: 50%;
    transform: translateX(-50%);
  }
  .articleVideoText{
    width: 375px!important;
  }
  .sameParticipationNew{
    width: 375px!important;height: 100%!important;
  }
}
>>>.messageDialog .van-dialog__footer{
  display: none;
}
.messageDialog{
  width: 32.3rem!important;
  overflow: visible!important;
}
.messageInfoBox{
  width: 100%;
  height: 44.8rem;
  background: #FFFFFF;
  border-radius: 15px;
  /* padding: 2.2rem 2.6rem 3.8rem;
  box-sizing: border-box; */
  text-align: center;
  position: relative;
}
.closefff{
  width: 5.6rem;height: auto;
  position: absolute;
  left: 0;right: 0;
  bottom: -0.9rem;
  margin: 0rem auto;
  transform: translateY(100%);
}
.messageInfoBoxTitle{
  width: 100%;height: auto;
  line-height: 2.1rem;
  padding: 2.2rem 2.6rem 0rem;
  box-sizing: border-box;
}
.messageInfoBoxTitleText{
  width: 100%;height: 2rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 2.1rem;
  color: #3E3E3E;
  line-height: 2.1rem;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid #1e948c;
}
.messageInfo_content{
  width: 100%;height: 36.2rem;
  padding: 0rem 2.6rem 0rem;
  box-sizing: border-box;
  overflow-y: auto;
}
.messageInfo_content>p{
  font-family: FZLTXIHJW;
  font-weight: normal;
  font-size: 1.4rem;
  color: #000000;
  line-height: 2.3rem;
  text-align: left;
  text-indent: 2em;
  margin: 1rem 0rem;
}
.messageInfo_content>p:last-child{
  margin-bottom: 0rem;
}


>>>.certificateCollectionDialog .van-dialog__footer{
  display: none;
}
.certificateCollectionDialog{
  width: 32.5rem!important;
  overflow: visible!important;
}
.certificateCollectionBox{
  width: 100%;height: auto;
  background: #FFFFFF;border-radius: 10px;
  padding: 4.5rem 2.4rem 1.8rem 2.3rem;
  box-sizing: border-box;
}
.certificateCollection_title{
  width: 100%;height: auto;
  margin-bottom: 1.8rem;
}
.certificateCollection_title>span{
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  font-size: 1.6rem;
  color: #000000;
  line-height: 1.6rem;
}
.certificateCollection_title>span:first-child{
  width: 9.8rem;height: auto;
  display: inline-block;
  text-align: center;
  position: relative;
}
.certificateCollection_title>span:first-child::after{
  content: " ";width: 9.8rem;height: 0.1rem;
  display: block;background-color: #040000 ;
  position: absolute;left: 0;bottom: -0.3rem;
}
.certificateCollection_content{
  width: 100%;height: auto;
  margin-bottom: 1.8rem;
}
.certificateCollection_content>p{
  font-family: FZLTXIHJW;
  font-weight: normal;
  font-size: 16px;
  color: #000000;
  line-height: 2.8rem;
  margin: 0rem auto;
  
}
.certificateCollection_content>p:first-child{
  margin-bottom: 1.2rem;
}
.certificateCollection_buttonBox{
  width: 100%;height: auto;
  display: flex;align-items: center;
  justify-content: center;
}
.certificateCollection_buttonBox>div{
  width: 18.9rem;height: 3.2rem;
  line-height: 3.2rem;text-align: center;
  background: #2D9C95;
  border-radius: 0.6rem;
  font-family: FZLTZHK;
  font-weight: normal;
  font-size: 1.6rem;
  color: #FFFFFF;
}
.certificateCollection_remark{
  width: 27.9rem;height: AutoCAD;
  background: rgba(91,171,165,0.1);
  border-radius: 1.2rem;
  border: 1px solid #2D9C95;
  margin-top: 1.6rem;padding: 1.3rem 1.25rem;
  box-sizing: border-box;
}
.certificateCollection_remarkOne{
  font-family: FZLTZHK;
  font-weight: normal;
  font-size: 1.2rem;
  color: #2D9C95;
  line-height: 2rem;
  
}
.certificateCollection_remarkTwo{
  margin: 1rem 0rem;
}
.certificateCollection_remarkTwo,.certificateCollection_remarlThree{
  font-family: FZLTZHK;
  font-weight: normal;
  font-size: 1.2rem;
  color: #000000;
  line-height: 2rem;
}
.certificateCollection_remarlFour{
  font-family: FZLTZHK;
  font-weight: normal;
  font-size: 1.2rem;
  color: #2D9C95;
  line-height: 2rem;
}


.expressBox{
  width: 100%;height: 44.5rem;
  background: #FFFFFF;border-radius: 10px;
  padding: 3.1rem 1.9rem 3.8rem;
  box-sizing: border-box;
}
.express_title{
  font-family: FZLTXIHJW;
  font-weight: normal;
  font-size: 1.6rem;
  color: #000000;
  line-height: 1.6rem;
}
.express_options{
  width: 100%;height: auto;
  margin-top: 2.5rem;
}
.express_label{
  width: 100%;height: auto;
  line-height: 1.5rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 1.5rem;
  color: #1E948C;
}
.express_options>input{
  width: 100%;height: 4.1rem;
  line-height: 4.1rem;background: #FFFFFF;
  border-radius: 0.5rem;border: 1px solid #1E948C;
  margin-top: 1rem;padding: 0rem 1.2rem;box-sizing: border-box;
  font-size: 1.5rem;
}
.express_options>input::placeholder{
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 1.5rem;
  color: #959494;
}
.express_submit{
  width: 16.8rem;height: 4.1rem;
  line-height: 4.1rem;text-align: center;
  background: #1E948C;border-radius: 0.5rem;
  font-family: Source Han Sans CN;font-weight: 500;
  font-size: 1.9rem;color: #FFFFFF;
  margin: 5.2rem auto 0rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue